import { type FunctionComponent } from 'react'
import { PageTitle } from '@which/seatbelt'

import { FreeAccountExclusive } from '../../home/components/FreeAccountExclusive'
import styles from './FreeAccountPage.module.scss'

const WelcomePage: FunctionComponent = () => {
  const image = {
    src: 'https://media.which.gpp.io/prod/images/ar_2to1_700x350/0876149fc87b-ecoverbathroom-cleaner-500mlwh23917-0032-01.webp',
    alt: 'Ecover Bathroom Cleaner Spray Mint & Cucumber',
    sources: [{ media: '', sizes: 'two-to-one', srcset: '', type: '' }],
    renditions: [],
    caption: '',
    dimensions: {
      height: '350',
      width: '700',
    },
    id: 'ecover-bathroom-cleaner-spray-mint-cucumber',
  }

  return (
    <section className={styles.welcomePage}>
      <div className={styles.centre}>
        <PageTitle
          pageTitle="Welcome to your Which? free account"
          pageTitleTag="h1"
          standfirst="You’re logged in and ready to go!"
        />
        <div className={styles.redRectangle} aria-hidden="true" />
      </div>
      <FreeAccountExclusive
        title="Your free fortnightly recommendation — it’s on us"
        description="For this selection, our editor has picked a Best Buy cleaning spray our expert testers loved."
        image={image}
        forceShow={true}
      />
    </section>
  )
}

export default WelcomePage
